export const ROLES = 'roles@allRoles';

export default {
    [ROLES]: {
        url: 'role/get/all',
    }
};
